module.exports = __webpack_public_path__ + "static/media/dogs.fe818eac.jpg";